import Column from '@sdk/components/ui/spacing/Column';
import Picker from '@sdk/components/forms/Picker';
import EditablePicker from '@sdk/components/forms/EditablePicker';
import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import useAuth from '@sdk/authentication/useAuth';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { TabType } from '@web/settings/types';
import RowSpaceBetween from '@web/settings/components/RowSpaceBetween';
import { useUserOrgSettings } from '@web/settings/UserOrgSettingsContext';
import { useSettingsErrorsContext } from '@web/settings/SettingsErrorContext';
import {
  getShiftBreakDefaultDuration,
  validateShiftBreakDefaultDuration,
} from '@web/settings/components/schedule/BreaksV1/standardBreaks.utils';
import { BREAK_DURATION_OPTIONS, BREAK_OPTIONS, FIELD_WIDTH_205 } from '@web/settings/constants';

const StandardBreaks = () => {
  const { currentUser } = useAuth();
  const { toggleError } = useSettingsErrorsContext();
  const { userOrgSettings, onUserOrgSettingsChange } = useUserOrgSettings();
  const { shiftBreakType, shiftBreakDefaultDuration } = userOrgSettings;

  return (
    <>
      <Column pBottom={20}>
        <RowSpaceBetween>
          <Column>
            <Text14 semiBold themeColor={ThemeColorType.gray}>
              {gettext('Paid or unpaid breaks')}
            </Text14>
          </Column>
          <Picker
            disabled={!currentUser.isAdmin}
            options={BREAK_OPTIONS}
            value={shiftBreakType}
            onChange={(value: number): void => onUserOrgSettingsChange({ shiftBreakType: value })}
            customWidth={FIELD_WIDTH_205}
          />
        </RowSpaceBetween>
      </Column>

      <Column pBottom={20}>
        <RowSpaceBetween>
          <Column>
            <Text14 semiBold themeColor={ThemeColorType.gray}>
              {gettext('Default break duration on shifts')}
            </Text14>
            <Text14 themeColor={ThemeColorType.gray}>
              {gettext('Set the break duration that will populate for new shifts:')}
            </Text14>
          </Column>
          <EditablePicker
            disabled={!currentUser.isAdmin}
            options={BREAK_DURATION_OPTIONS}
            value={getShiftBreakDefaultDuration(shiftBreakDefaultDuration)}
            postfix={shiftBreakDefaultDuration ? 'Minutes' : null}
            onChange={(value: number): void => {
              onUserOrgSettingsChange({
                shiftBreakDefaultDuration: value,
              });
              toggleError(
                TabType.schedule,
                'shiftBreakDefaultDuration',
                !validateShiftBreakDefaultDuration(value)
              );
            }}
            customWidth={FIELD_WIDTH_205}
            placeholder="No break"
            usePickerValueWhenDisplay
            invalid={!validateShiftBreakDefaultDuration(shiftBreakDefaultDuration)}
          />
        </RowSpaceBetween>
      </Column>
    </>
  );
};

export default StandardBreaks;
